import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import Spinner from "../../components/spinner";
import { useToaster } from "../../context/ToasterContext";
import "../../styles/payment-webview.scss";
import EqualSplitIcon from "../../assets/icons/equal.png";
import UnequalSplitIcon from "../../assets/icons/not-equal.png";
import { ReactComponent as DollarCircleIcon } from "../../assets/icons/dollar-circle.svg";
import { ReactComponent as WhatAmIPayingForIcon } from "../../assets/icons/what-am-i-paying-for.svg";
import { ReactComponent as UsersIcon } from "../../assets/icons/users.svg";
import { useShopDetailsContext } from '../../context/ShopDetailsContext';
import { fetchShopDetailsByShopLink, getMinimumAmountForCurrency, returnShortCodeOfPaymentMethod } from "../../utils/global";
import PoweredByComponent from "../../webview-components/powered-by";
import MerchantLogoHeader from "../../webview-components/merchant-logo-header";

const CreatePaymentLink = () => {
  useEffect(() => {
    document.title = "Get a link & Start sharing - SuperCheckout";
  }, []);

  let { shop } = useParams();
  //console.log("useParams shopLink: " + shop);

  const { toaster } = useToaster();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [noOfPax, setNoOfPax] = useState(null);
  const [amount, setAmount] = useState("");
  const [whatAreYouPayingFor, setWhatAreYouPayingFor] = useState("");
  const [shopDetails, setShopDetails] = useState({});

  const [noOfPax_custom, setNoOfPax_custom] = useState();
  const increment_noOfPax = () => setNoOfPax_custom(prevCount => Math.min(25, (prevCount ?? 10) + 1));
  const decrement_noOfPax = () => setNoOfPax_custom(prevCount => Math.max(11, (prevCount ?? 11) - 1));

  const [createOrderApi_loading, setCreateOrderApi_loading] = useState(false);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const { setShopDetailsContext } = useShopDetailsContext();

  const [step, setStep] = useState(0);
  const [animation, setAnimation] = useState("active");
  const steps = [
    { id: "amount" },
    { id: "pax" },
  ];

  useEffect(() => {
    if(noOfPax_custom !== null){
      setNoOfPax(noOfPax_custom);
    }
  }, [noOfPax_custom]);

  useEffect(() => {
    if(noOfPax < 11){
      setNoOfPax_custom(null);
    }
  }, [noOfPax]);

  useEffect(() => {
    const fetchShopDetails = async () => {
      try {
        const response = await fetchShopDetailsByShopLink(shop);

        setShopDetails(response);

        setShopDetailsContext(prev => ({
          ...prev,
          user_image: response.user_image,
          shop_name: response.shop_name,
          meta_data: response.meta_data
        }));

        let is_superpay_enabled = false;
        if(response.meta_data){
          if(typeof response.meta_data.superpay !== 'undefined'){
            if(response.meta_data.superpay === true){
              is_superpay_enabled = true;
            }
          }
        }

        if(is_superpay_enabled === false){
          navigate("/"+ shop +"/pay");
        }

        setLoading(false);
      } catch (err) {
        console.log(err);
      } finally {
        //setLoading(false);
      }
    };

    fetchShopDetails();
  }, []);

  const createOrderApiCall = async () => {
    if(amount === '' || amount === null || amount === 0){
      toaster.error("Please enter total amount to be paid!");

      return;
    }
    else if(parseFloat(amount) < parseFloat(getMinimumAmountForCurrency(shopDetails.user_currency))){
      toaster.error("Sorry! The entered amount is below the minimum required to proceed with the transaction.");

      return;
    }

    if(noOfPax === '' || noOfPax === null || noOfPax === 0){
      toaster.error("Please select the number of people paying together!");

      return;
    }

    let total_amount = amount * noOfPax;
    console.log(total_amount);
    
    try {
      setCreateOrderApi_loading(true);

      let orderData = {
        order_id: crypto.randomUUID(),
        cart_items: "",
        total_amount: total_amount,
        subtotal: total_amount,
        shipping: "0.00",
        tax: "0.00",
        discount: "0.00",
        meta_data: "",
      };

      if(whatAreYouPayingFor !== '' && whatAreYouPayingFor !== null && whatAreYouPayingFor !== 0){
        orderData['cart_items'] = [{"name":whatAreYouPayingFor,"description":"","image_link": "","price":total_amount,"tax":"0.00","quantity":1,"type":"product"}];
      }

      let requestData = {
        order_data: orderData,
        currency: shopDetails.user_currency,
        merchant_shop: shop
      };

      let createOrderApiCallResponse = await api.post(
        `sdk/orders/create-payment-link`, JSON.stringify(requestData)
      );
      console.log(createOrderApiCallResponse);

      //setCreateOrderApi_loading(false);

      if (
        (createOrderApiCallResponse.status === 200 ||
          createOrderApiCallResponse.status === 201) &&
        createOrderApiCallResponse.data
      ) {
        if (createOrderApiCallResponse.data) {
          localStorage.removeItem("sc_pn_fcmTokenSent");
          
          let payment_link = createOrderApiCallResponse.data.payment_link;
          if (payment_link.includes("/checkout")) {
            const parts = payment_link.split("/checkout/");
            if (parts.length > 1) {
              getOrderDetailsApiCall(parts[1]);
            }
          }
          else{
            window.location.href = createOrderApiCallResponse.data.payment_link;
          }
        }
      } else {
        if (
          createOrderApiCallResponse.data.errorMessage &&
          createOrderApiCallResponse.data.errorMessage.length
        ) {
          toaster.error(createOrderApiCallResponse.data.errorMessage);
        } else {
          toaster.error("Something went wrong");
        }
      }
    } catch (error) {
      setCreateOrderApi_loading(false);
      
      console.log("Exception: ", error);

      toaster.error("Something went wrong");
    }
  };

  const getOrderDetailsApiCall = async (id) => {
    try {
      let createOrderApiCallResponse = await api.get(
        `sdk/orders/get-order-data/${id}/1`
      );
      console.log(createOrderApiCallResponse);

      setCreateOrderApi_loading(false);

      if (
        (createOrderApiCallResponse.status === 200 ||
          createOrderApiCallResponse.status === 201) &&
        createOrderApiCallResponse.data
      ) {
        if (createOrderApiCallResponse.data) {
          navigate("/"+ returnShortCodeOfPaymentMethod(createOrderApiCallResponse.data.payment_method) +"/"+ id +"?total_pax="+ noOfPax +"&superpay=true");
        }
      } else {
        if (
          createOrderApiCallResponse.data.errorMessage &&
          createOrderApiCallResponse.data.errorMessage.length
        ) {
          toaster.error(createOrderApiCallResponse.data.errorMessage);
        } else {
          toaster.error("Something went wrong");
        }
      }
    } catch (error) {
      setCreateOrderApi_loading(false);
      
      console.log("Exception: ", error);

      toaster.error("Something went wrong");
    }
  };

  return (
    <>
      <div className="payment-page-wrapper">
        {loading && <Spinner />}

        {!loading && 
          <div>
            <div className="payment-form-wrapper">
              <div className="form-wrapper text-start mt-3">
                <MerchantLogoHeader shop_name={shopDetails.shop_name} user_image={shopDetails.user_image}></MerchantLogoHeader>

                <form id="payment-form">
                  <div className="typeform-container">
                    {steps.map((s, index) => {
                      if (s.id === "amount") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <div className="whiteCard mt-2">
                            <div className="input-wrapper mt-0 pt-0">
                              <label className="form-label">
                                <DollarCircleIcon className="DollarCircleIcon align-middle" />
                                {' '}
                                <span className="align-middle">Each person pays</span>
                              </label>

                              <div className="input-group mb-3">
                                <span className="input-group-text">{shopDetails.currency_with_symbol}</span>

                                <input type="number" id="amount" className="form-control" placeholder="e.g. 500" min="0" step="0.01" inputMode="decimal" value={amount || ''} disabled={loading} onChange={(e) => {
                                  setAmount(e.target.value);
                                }} />
                              </div>
                            </div>

                            <div className="input-wrapper mt-0 pt-0">
                              <label className="form-label">
                                <WhatAmIPayingForIcon className="DollarCircleIcon align-middle" />
                                {' '}
                                <span className="align-middle">What are you paying for?</span>
                              </label>

                              <div className="mb-3">
                                <input type="text" id="whatAreYouPayingFor" className="form-control" placeholder="e.g. Name of service or product" value={whatAreYouPayingFor || ''} disabled={loading} onChange={(e) => {
                                  setWhatAreYouPayingFor(e.target.value);
                                }} />
                              </div>
                            </div>

                            <div className="input-wrapper mb-0">
                              <div className="mt-0 mb-3">
                                <label className="form-label noMarginBottom">
                                  <UsersIcon className="DollarCircleIcon align-middle" />
                                  {' '}
                                  <span className="align-middle">How many people are sharing the payment?</span>
                                </label>

                                <div className="row text-center g-2 noOfPax-cards-container">
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_2" className={`single-no-pax-container ${
                                      noOfPax === 2 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(2)}>
                                      2
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_3" className={`single-no-pax-container ${
                                      noOfPax === 3 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(3)}>
                                      3
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_4" className={`single-no-pax-container ${
                                      noOfPax === 4 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(4)}>
                                      4
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_5" className={`single-no-pax-container ${
                                      noOfPax === 5 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(5)}>
                                      5
                                    </div>
                                  </div>
                                  <div id="noOfPax_singleCard_6" className="col-2">
                                    <div className={`single-no-pax-container ${
                                      noOfPax === 6 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(6)}>
                                      6
                                    </div>
                                  </div>
                                  <div id="noOfPax_singleCard_7" className="col-2">
                                    <div className={`single-no-pax-container ${
                                      noOfPax === 7 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(7)}>
                                      7
                                    </div>
                                  </div>
                                </div>
                                <div className="row text-center g-2 noOfPax-cards-container">
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_8" className={`single-no-pax-container ${
                                      noOfPax === 8 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(8)}>
                                      8
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div id="noOfPax_singleCard_9" className={`single-no-pax-container ${
                                      noOfPax === 9 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(9)}>
                                      9
                                    </div>
                                  </div>
                                  <div id="noOfPax_singleCard_10" className="col-2">
                                    <div className={`single-no-pax-container ${
                                      noOfPax === 10 ? `active` : ""
                                    }`} onClick={() => setNoOfPax(10)}>
                                      10
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="">
                                      <div className="input-group noOfPax_custom_inputGroup mb-3">
                                        <button className="btn btn-primary" type="button" id="noOfPax_customBtn_minus" onClick={decrement_noOfPax}>-</button>

                                        <input type="text" id="noOfPax_customText" className="form-control" readOnly placeholder="Eg.: 15" value={noOfPax_custom ?? ""} onChange={(e) => {
                                          setNoOfPax(e.target.value);
                                        }} />

                                        <button className="btn btn-primary" type="button" id="noOfPax_customBtn_plus" onClick={increment_noOfPax}>+</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="">
                              <ButtonComponent
                                type="button"
                                id="get_payment_link_btn"
                                className="btn btn-primary btn-pool-shadow btn-pool-full"
                                disabled={createOrderApi_loading}
                                label={createOrderApi_loading ? "Please wait..." : "Start sharing"}
                                variant="primary"
                                size="md"
                                onClick={() => createOrderApiCall()}
                              ></ButtonComponent>
                            </div>
                          </div>
                        </div>
                      }
                    })}
                  </div>
                </form>

                <PoweredByComponent></PoweredByComponent>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
};

export default CreatePaymentLink;
